import { gql } from '@adc/sdk'

// TODO: This is just a fragment so we should not need it
/* eslint-disable @adc/named-gql-operations */
export const FEATURE_FLAGS_FRAGMENT = gql`
  fragment FeatureFlags on User {
    feature_flags(
      filters: {
        flagKeys: [
          "fe.resi.reo.show_primary_residence_modal"
          "fe.resi.new_tps_pdp"
          "fe.resi.direct_offers"
          "fe.resi.investor.preference"
          "fe.resi.reo.show_primary_residence_modal"
          "fe.resi.reo.final_offer_sellers"
          "fe.resi.enable-web-remote-bidding"
          "app.enable-pdp-design-2025"
          #
          # Implicit ui-adc flags
          #
          "fe.resi.ie-banner"
          "fe.resi.short-sales-header"
          "fe.resi.redesign-header-2021"
          "fe.resi.saved_purchase_profile"
          "fe.resi.reo.final_offer_sellers"
          "fe.resi.new_search_auction_date_default_sort"
        ]
        context: $context
      }
    )
  }
`
